import { money } from "@/lib/format";

const TAX_COLS = ["taxable", "igst", "cgst", "sgst", "cess"];

const Table = ({ title, heading, rows }) => (
  <div className="border border-border">
    <p className="border-b border-border px-4 py-2 font-display text-sm font-bold">{title}</p>
    <table className="dense-table w-full">
      <thead><tr><th>{heading}</th><th className="text-right">Taxable</th><th className="text-right">IGST</th>
        <th className="text-right">CGST</th><th className="text-right">SGST</th><th className="text-right">Cess</th></tr></thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.nature}>
            <td>{r.nature}</td>
            {TAX_COLS.map((c) => <td key={c} className="num text-right">{money(r[c])}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Gstr3bTab = ({ gstr3b }) => (
  <div className="space-y-4" data-testid="gstr3b-view">
    <Table title="3.1 Outward supplies" heading="Nature of supply" rows={gstr3b.table_3_1} />
    <Table title="4. Eligible ITC" heading="Details" rows={gstr3b.table_4_itc} />
    <div className="grid gap-px border border-border bg-border sm:grid-cols-5">
      {[["IGST payable", gstr3b.net_liability.igst], ["CGST payable", gstr3b.net_liability.cgst],
        ["SGST payable", gstr3b.net_liability.sgst], ["Cess", gstr3b.net_liability.cess],
        ["Total payable", gstr3b.net_liability.total_payable]].map(([k, v]) => (
        <div key={k} className="bg-background p-4" data-testid={`net-${k.replace(/\s/g, "-")}`}>
          <p className="text-[10px] uppercase tracking-widest text-muted-foreground">{k}</p>
          <p className="num mt-1 font-semibold">{money(v)}</p>
        </div>
      ))}
    </div>
    <p className="text-xs text-muted-foreground">{gstr3b.note}</p>
  </div>
);
